var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"news-date"},[_c('time',{attrs:{"datetime":_vm.newsDate}},[_vm._v(_vm._s(_vm.getNewsDate( _vm.newsDate )))])])}
var staticRenderFns = []

export { render, staticRenderFns }